import { render, staticRenderFns } from "./ListaEscalas.vue?vue&type=template&id=ef09bfd0&"
import script from "./ListaEscalas.vue?vue&type=script&lang=js&"
export * from "./ListaEscalas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports